/**
 * O que a fila e o painel do Caso escrevem sobre o aceite da avaliadora (`TP-065`). A situação vem do back (`D5`):
 * aqui só se escreve, nunca se recalcula.
 */

import { formatarDataHora, formatarHora, formatarRelativo } from '../dominio/datas';
import { ROTULO_DO_TURNO, type AcionamentoDaAvaliadora } from './acionamento';

/** A coluna do prazo na fila: até quando, há quanto venceu, ou quando aceitou. */
export function textoDoPrazo(a: AcionamentoDaAvaliadora, agora: Date = new Date()): string {
  if (a.situacao === 'aceita') {
    return a.aceitaEm !== null ? `aceita ${formatarRelativo(a.aceitaEm, agora)}` : 'aceita';
  }
  if (a.prazoAceiteEm === null) return 'sem prazo de aceite';
  if (a.situacao === 'aceite_vencido') return `venceu ${formatarRelativo(a.prazoAceiteEm, agora)}`;
  return `até ${formatarDataHora(a.prazoAceiteEm)}`;
}

/** A linha da frente de avaliação no detalhe do Caso: o prazo, o vencido ou o turno aceito. */
export function textoDoAcionamento(a: AcionamentoDaAvaliadora, agora: Date = new Date()): string {
  const quem = a.avaliadora !== null ? ` · ${a.avaliadora}` : '';
  if (a.situacao === 'aceita') {
    return `Avaliadora aceitou${a.turno !== null ? ` · turno da ${ROTULO_DO_TURNO[a.turno].toLowerCase()}` : ''}${quem}`;
  }
  if (a.prazoAceiteEm === null) return `Aguardando o aceite da avaliadora${quem}`;
  if (a.situacao === 'aceite_vencido') {
    return `Aceite vencido ${formatarRelativo(a.prazoAceiteEm, agora)}: a coordenação vê na fila da avaliação${quem}`;
  }
  return `Aguardando o aceite até ${formatarHora(a.prazoAceiteEm)}${quem}`;
}
